// src/components/ui/PageTransition/index.tsx
import React, { useState } from "react";
import { PageEnter } from "./styles";

/**
 * Entrada suave de página (fade + slide-up) aplicada a cada troca de rota.
 * O elemento da rota remonta na navegação, então a animação roda uma vez
 * por entrada de tela. Ao terminar, a animação é removida para o wrapper
 * não reter transform e quebrar descendentes position:fixed (ver styles.ts).
 */
export default function PageTransition({
  children,
}: {
  children: React.ReactNode;
}) {
  const [done, setDone] = useState(false);

  return (
    <PageEnter
      $done={done}
      onAnimationEnd={(e) => {
        if (e.target === e.currentTarget) setDone(true);
      }}
    >
      {children}
    </PageEnter>
  );
}
